import { routerUrls } from '@/configs/routes/routerUrls';

const FROM_PARAM = 'from';

/** Вход токеном Яндекса, после которого вернёмся на `from` (путь со строкой запроса) */
export const getLegacyLoginUrl = (from: string): string =>
  `${routerUrls.login}?${new URLSearchParams({ [FROM_PARAM]: from })}`;

/**
 * Куда вернуться после входа токеном. Параметр приходит из адресной строки, поэтому берём только
 * свои пути: `//host` и `/\host` браузер считает адресом другого сайта
 */
export const getLegacyLoginReturnPath = (search: string): string => {
  const from = new URLSearchParams(search).get(FROM_PARAM);

  if (!from || !from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) {
    return routerUrls.root;
  }

  return from;
};
